import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import { ReactComponent as FileIcon } from "../../../../assets/upload-file.svg";
import {
  EventDetailsData,
  TicketDetailsData,
} from "../../../../constants/jsonData";
import QRCode from "qrcode.react";
import PlusButton from "../../../../component/common/PlusButton";
import MinusButton from "../../../../component/common/MinusButton";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
function TicketDesign({ setTicketDesign }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <div className="p-3">
        <div className="flex items-center gap-1 bg-white ">
          <IoIosArrowBack
            className="text-dark-bluecursor-pointer"
            onClick={() => setTicketDesign(false)}
          />
          <h4 className="text-dark-bluefont-medium py-3 text-lg">
            Ticket Design
          </h4>
        </div>
        <section>
          <div className="mt-3 p-3 bg-white">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div>
                  <div className="mb-3">
                    <section>
                      <h4 className="text-[#24252D] font-medium text-base mt-[20px] mb-2">
                        Ticket Creative
                      </h4>
                      <div
                        className="h-[70px]  bg-[#F5F6FA] relative border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center cursor-pointer"
                        id="dropzone"
                      >
                        <input
                          type="file"
                          accept=".pdf"
                          className="absolute w-full h-full 
            
            opacity-0 z-50"
                        />
                        <div className="text-center flex  items-center justify-center gap-3">
                          <FileIcon />
                          <span className="text-xs text-[#515B6B] font-medium">
                            Upload File
                          </span>
                          <span className="text-xs text-[#515B6B] font-medium">
                            Dimension: 2480 x 868 px
                          </span>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="" className="font-medium text-base mb-2">
                      Terms & Conditions *
                    </label>

                    <textarea
                      className="custom-input bg-[#F5F6FA]"
                      placeholder="AJ Ballroom Section 2"
                      name=""
                      id=""
                      rows="10"
                      cols="30"
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="" className="font-medium text-base mb-2">
                      Brand Tie ups
                    </label>

                    <p
                      className="text-sm text-center py-3 bg-[#f0f2f7] rounded cursor-pointer"
                      onClick={() => setOpen(true)}
                    >
                      Add Brand details
                    </p>
                    <div className="text-center">
                      <button className="auth-button bg-[#407BFF] w-50 mt-10 justify-center ">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="bg-[#f0f2f7]">
                  <label className="p-2 text-sm text-[#263238]" htmlFor="">
                    Preview
                  </label>
                  <section className="m-3 bg-white">
                    <div className="p-3">
                      <div
                        className="h-[200px]  bg-[#F5F6FA] relative border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center cursor-pointer "
                        id="dropzone"
                      >
                        <input
                          type="file"
                          accept=".pdf"
                          className="absolute w-full h-full 
            
            opacity-0 z-50"
                        />
                        <div className="text-center flex  items-center justify-center gap-3 ">
                          <FileIcon />
                          <span className="text-xs text-[#515B6B] font-medium">
                            Upload File
                          </span>
                        </div>
                        <p
                          className="absolute right-[3rem] bottom-[-1.5rem] bg-[#407BFF] text-white shadow font-medium text-xs p-1"
                          style={{
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          This is your E-Ticket
                        </p>
                      </div>
                      <div className="pt-4">
                        <h4 className="text-dark-bluefont-semibold text-base">
                          Arijit Singh Live in Dubai
                        </h4>
                        <div className="row">
                          <div className="col-lg-7">
                            <h4 className="text-dark-blue text-xs font-medium mb-2">
                              Booking Details
                            </h4>
                            <hr className="bg-[#C3D0ED] mb-2" />
                            <div className="grid grid-cols-3 gap-2 py-2">
                              <div>
                                <label
                                  htmlFor=""
                                  className="text-[#4E5969] text-[10px] font-normal"
                                >
                                  Order Amount
                                </label>
                                <h5 className="font-semibold text-[10px]">
                                  AED 900.00
                                </h5>
                              </div>
                              <div>
                                <label
                                  htmlFor=""
                                  className="text-[#4E5969] text-[10px] font-normal"
                                >
                                  Order Amount
                                </label>
                                <h5 className="font-semibold text-[10px]">
                                  AED 900.00
                                </h5>
                              </div>
                              <div>
                                <label
                                  htmlFor=""
                                  className="text-[#4E5969] text-[10px] font-normal"
                                >
                                  Order Amount
                                </label>
                                <h5 className="font-semibold text-[10px]">
                                  AED 900.00
                                </h5>
                              </div>
                            </div>
                            <hr className="bg-[#C3D0ED] mb-2" />
                            <div className="mb-3">
                              <h4 className="text-dark-blue text-xs font-medium mb-2">
                                Event Details
                              </h4>
                              <div>
                                {EventDetailsData.map((el, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center justify-between mb-3"
                                  >
                                    <h6 className="text-[#4E5969] text-[10px] font-normal">
                                      {el?.label}
                                    </h6>
                                    <p className="text-[10px] font-semibold">
                                      {el?.text}
                                    </p>
                                  </div>
                                ))}
                                <div></div>
                              </div>
                            </div>
                            <hr className="bg-[#C3D0ED] mb-2" />
                            <div className="mb-3">
                              <h4 className="text-dark-blue text-xs font-medium mb-2">
                                Ticket Details
                              </h4>
                              <div>
                                {TicketDetailsData.map((el, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-center justify-between mb-3"
                                  >
                                    <h6 className="text-[#4E5969] text-[10px] font-normal">
                                      {el?.label}
                                    </h6>
                                    <p className="text-[10px]  font-semibold">
                                      {el?.text}
                                    </p>
                                  </div>
                                ))}
                                <div></div>
                              </div>
                            </div>
                            <hr className="bg-[#C3D0ED] mb-2" />
                          </div>
                          <div className="col-lg-5 my-auto">
                            <h4 className="bg-[#F8B34B] text-white py-2 text-center font-semibold">
                              GOLD
                            </h4>
                            <QRCode
                              value="https://reactjs.org/"
                              renderAs="canvas"
                              style={{ width: "100%", height: "auto" }}
                            />
                            <div className="flex justify-center items-center flex-column gap-1 mt-2">
                              <span className="text-xs font-medium">
                                Order #: 111249
                              </span>
                              <span className="text-xs font-medium">
                                SEAT - T2S6
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="h-1 border-b-2 border-gray-300 border-dashed my-3"></div>
                      </div>
                      <div>
                        <h4 className="text-dark-blue text-xs font-medium mb-2">
                          Ticket Details
                        </h4>
                        <div className="h-1 border-b-2 border-gray-300 border-dashed my-3"></div>
                        <ul>
                          <li className="text-[10px] list-disc">
                            Terms & Conditions These terms and conditions govern
                            the purchase and use of tickets for events held at
                            Coca-Cola Arena Arena.
                          </li>
                          <li className="text-[10px] list-disc">
                            By purchasing a ticket, you agree to comply with
                            these Terms. Tickets are non-refundable and
                            non-transferable, except as required by law.
                          </li>
                          <li className="text-[10px] list-disc">
                            Each ticket admits one person only and must be
                            presented for entry.
                          </li>
                          <li className="text-[10px] list-disc">
                            The Ticket Holder must retain their ticket
                            throughout the event and may be asked to show it at
                            any time.
                          </li>
                          <li className="text-[10px] list-disc">
                            Entry to the Arena is subject to presenting a valid
                            ticket and may require proof of identity.
                          </li>
                          <li className="text-[10px] list-disc">
                            The Arena reserves the right to refuse admission or
                            remove any person who violates these Terms or
                            engages in disruptive behavior.
                          </li>
                        </ul>
                        <div className="grid grid-cols-5 mt-3">
                          <div className="flex flex-column items-center gap-2 ">
                            <h4 className="text-center text-[7px]">
                              Naming Rights Partner
                            </h4>
                            <img
                              src="/images/register-partner-1.svg"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="flex flex-column items-center gap-2 ">
                            <h4 className="text-center text-[7px]" htmlFor="">
                              Founding Partner
                            </h4>
                            <div className="flex gap-2">
                              <img
                                src="/images/register-partner-2.svg"
                                className="img-fluid"
                                alt=""
                              />
                              <img
                                src="/images/register-partner-3.svg"
                                className="img-fluid"
                                alt=""
                              />
                              <img
                                src="/images/register-partner-4.svg"
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="flex flex-column items-center gap-2 ">
                            <h4 className="text-center text-[7px]">
                              Official Partner
                            </h4>
                            <img
                              src="/images/register-partner-6.svg"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="flex flex-column items-center gap-2 ">
                            <h4 className="text-center text-[7px]">
                              Venue Creator
                            </h4>
                            <img
                              src="/images/register-partner-7.svg"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="flex flex-column items-center gap-2 ">
                            <h4 className="text-center text-[7px]">
                              Ticketing Partner
                            </h4>
                            <img
                              src="/images/register-partner-5.svg"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="d-flex flex-column align-items-end mt-5 pe-3">
                    <PlusButton />
                    <MinusButton />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Modal  */}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={"sm"}
        fullWidth={true}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle className="text-blue" id="responsive-dialog-title">
          {"Brand Tie ups"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="bg-[#F5F6FA]">
              <div>
                <label
                  htmlFor=""
                  className="font-medium text-base mb-2 text-[#06152B]"
                >
                  Category*
                </label>
                <input
                  type="text"
                  className="custom-input"
                  name=""
                  placeholder="Enter detail"
                  id=""
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor=""
                  className="font-medium text-base mb-2 text-[#06152B]"
                >
                  Logos*
                </label>

                <div
                  className="h-[50px] bg-white relative border-2 border-gray-300 border-dashed rounded-lg flex items-center justify-center cursor-pointer"
                  id="dropzone"
                >
                  <input
                    type="file"
                    accept=".pdf"
                    className="absolute w-full h-full 
            
            opacity-0 z-50"
                  />
                  <div className="text-center flex  items-center justify-center gap-3">
                    <FileIcon />
                    <span className="text-xs text-[#515B6B] font-medium">
                      Upload File
                    </span>
                    <span className="text-xs text-[#515B6B] font-medium">
                      Dimension: 180 x 180 px{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2">
                {[1, 2, 3, 4].map((el) => (
                  <div className="col mb-3 rounded-2">
                    <div className="bg-white h-28 w-full"></div>
                  </div>
                ))}
              </div>

              <p className="text-sm text-center py-3 bg-[#f0f2f7] rounded cursor-pointer">
                + Add more{" "}
              </p>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TicketDesign;
